module.exports = {"0":"Acceptance pending","1":"Accepted / in progress","2":"Rejected","3":"Finished","4":"Not answered","5":"Cancelled"};